import { normalize } from 'normalizr';
import * as actionTypes from '../actions/types';
import * as schemas from '../schemas';
import { getPreferences } from '../../utils';

const INITIAL_STATE = {
  entities: { reports: {} },
  allIds: [],
  loading: false,
  preferences: getPreferences('reports'),
  error: null,
  message: null,
  editing: {},
  preview: {},
};

const reportsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.REMOVE_REPORT:
    case actionTypes.ADD_REPORT:
    case actionTypes.GENERATE_PREVIEW_REPORT:
    case actionTypes.LOAD_REPORT:
    case actionTypes.LOAD_REPORTS: {
      return { ...state, loading: true, error: null };
    }

    case actionTypes.LOAD_REPORTS_SUCCESS: {
      const reports = action.payload.reports;
      const data = normalize(reports, schemas.reportListSchema);
      return {
        ...state,
        loading: false,
        allIds: data.result,
        entities: data.entities,
        preferences: {
          ...getPreferences('reports'), // reset filters
          ...action.payload.preferences,
        },
        totalCount: action.payload.reportsCount,
      };
    }

    case actionTypes.ADD_REPORT_SUCCESS: {
      return {
        ...state,
        allIds: [...state.allIds, action.payload.id],
        entities: {
          ...state.entities,
          reports: {
            ...state.entities.reports,
            [action.payload.id]: action.payload,
          },
        },
        loading: false,
        message: 'An report has been added',
        editing: action.payload,
      };
    }

    case actionTypes.GENERATE_PREVIEW_REPORT_SUCCESS: {
      return {
        ...state,
        preview: action.payload,
        loading: false,
      };
    }

    case actionTypes.LOAD_REPORT_SUCCESS: {
      return {
        ...state,
        editing: action.payload,
        loading: false,
      };
    }

    case actionTypes.CLEAR_EDITING_REPORT: {
      return {
        ...state,
        editing: {},
      };
    }

    case actionTypes.CLEAR_PREVIEW_REPORT: {
      return {
        ...state,
        preview: {},
      };
    }

    case actionTypes.REMOVE_REPORT_SUCCESS: {
      const deletedId = action.payload.deletedId;
      const { [deletedId]: removed, ...reports } = state.entities.reports;
      return {
        ...state,
        allIds: state.allIds.filter((id) => id !== deletedId),
        entities: {
          ...state.entities,
          reports,
        },
        message: 'An report has been removed',
      };
    }

    case actionTypes.ADD_REPORT_FAIL:
    case actionTypes.GENERATE_PREVIEW_REPORT_FAIL:
    case actionTypes.REMOVE_REPORT_FAIL:
    case actionTypes.LOAD_REPORT_FAIL:
    case actionTypes.LOAD_REPORTS_FAIL: {
      return { ...state, loading: false, error: action.payload };
    }

    case actionTypes.CLEAR_REPORT_MESSAGE: {
      return { ...state, message: null };
    }

    case actionTypes.UPDATE_PREFERENCES: {
      const { key, subKey, value } = action.payload;
      if (key === 'reports') {
        return {
          ...state,
          preferences: { ...state.preferences, [subKey]: value },
        };
      }
      return state;
    }

    case actionTypes.RESET_PREFERENCES: {
      return { ...state, preferences: { ...action.payload.reports } };
    }

    default:
      return state;
  }
};

export default reportsReducer;
